import React from 'react'
import {OfferUpdateProvider} from "../../../context/OfferUpdateContext";
import OfferUpdateContainer from "./OfferUpdateContainer";

const OfferUpdateContextContainer = () => {

    return(
        <React.Fragment>
            <OfferUpdateProvider>
                <OfferUpdateContainer />
            </OfferUpdateProvider>
        </React.Fragment>
    )
}
export default OfferUpdateContextContainer